<template>
<button class="info-button" @click.stop.prevent="toggle" :id="id">
	<i class="icon icon-info"></i>
	<Popper ref="menu" :target_id="id" :append_to_body="true" :offset="[0,10]" >
		<div @click.stop.prevent class="info-menu">
			<slot></slot>
		</div>
	</Popper>
</button>
</template>

<script>
import Popper from "@/../submodules/vue-base/components/Popper";
import {
    v4 as uuidv4
} from 'uuid';
export default {

	name: "Info",

	components: {
		Popper
	},

	data(){
		var id = uuidv4();
		return {
			id:id
		}
	},

	methods: {
		toggle(){
			this.$refs.menu.toggle();
		},
		close(){
			this.$refs.menu.close();
		},
	}

}

</script>